import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Footer_1 from '../../assets/images/logo/logo.png'
import Footer_2 from '../../assets/images/tiny-footer/01.png'
import Footer_3 from '../../assets/images/tiny-footer/02.png'
import Footer_4 from '../../assets/images/tiny-footer/03.png'
import Footer_5 from '../../assets/images/tiny-footer/04.png'
import Footer_6 from '../../assets/images/tiny-footer/05.png'


const Payment = {
    slidesToShow: 5,
    SlideToScroll: 1,
    Infinity: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000
}
const Footer2 = () => {
    return (
        <>
            <footer>
                <div id="footer-two" className="footer-two-main-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-4">
                                <div className="footer-two-block">
                                    <div className="footer-two-logo">
                                        <Link to="/" title="">
                                            <img
                                                src={Footer_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                    </div>
                                    <ul className="footer-two-dtls">
                                        <li>555 A, East Manster Street, Ready Halley Neon, Uk 4512</li>
                                        <li>
                                            <Link to="tel:+4733378901" title="">
                                                +00 123 45678 44
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="mailto:supportinfo@gmail.com" title="">
                                                supportinfo@gmail.com
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="footer-two-social-icons">
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="" />
                                            <i className="flaticon-linkedin" />
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-8">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-two-widget">
                                            <h4 className="footer-two-widget-heading">Quick Links</h4>
                                            <ul className="footer-two-menu">
                                                <li>
                                                    <Link to="/" title="">
                                                        Home page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Aboutus" title="">
                                                        About page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Shop" title="">
                                                        Shop Page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/BlogDetails" title="">
                                                        Blog Details
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Contactus" title="">
                                                        Contacts us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/shop-filter" title="">
                                                        Products
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-two-widget">
                                            <h4 className="footer-two-widget-heading">Our Policy</h4>
                                            <ul className="footer-two-menu">
                                                <li>
                                                    <Link to="#" title="">
                                                        Privacy Protection
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Safe Payments
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Terms of Service
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Privace&Policy" title="">
                                                        Privacy Policy
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Shipping &amp; Returns
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="footer-two-widget">
                                            <h4 className="footer-two-widget-heading">Profile</h4>
                                            <ul className="footer-two-menu">
                                                <li>
                                                    <Link to="#" title="">
                                                        My Account
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Checkout" title="">
                                                        Checkout
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Order Tracking
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Faq" title="">
                                                        Help &amp; Support
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tiny-footer-two-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-6">
                                <div className="footer-two-coyright">
                                    Copyright © 2025. All Rights Reserved.
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 text-end">
                                <div className="tiny-footer-two-payment-img">
                                    <Slider className="slider tiny-two-payment-autoplay" {...Payment}>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            {" "}
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_6}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            {" "}
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_5}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="#" title="">
                                                <img
                                                    src={Footer_6}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer2
